export default class StaffStopRequest {
  emailAddress = [];
  constructor(datas) {
    for (var i = 0; i < datas.length; i++) {
      this.emailAddress.push(datas[i].email);
    }
  }
}
